var map = {
	"./Disnep/Disnep_button_01": 7602,
	"./Disnep/Disnep_button_01.json": 7602,
	"./Disnep/Disnep_button_03": 3216,
	"./Disnep/Disnep_button_03.json": 3216,
	"./earth/earth_button_01": 4702,
	"./earth/earth_button_01.json": 4702,
	"./earth/earth_button_02": 2143,
	"./earth/earth_button_02.json": 2143,
	"./earth/earth_button_03": 3132,
	"./earth/earth_button_03.json": 3132,
	"./mb-418/mb-418_button_01": 3346,
	"./mb-418/mb-418_button_01.json": 3346,
	"./mb-418/mb-418_button_02": 4371,
	"./mb-418/mb-418_button_02.json": 4371,
	"./mb-418/mb-418_button_03": 3040,
	"./mb-418/mb-418_button_03.json": 3040,
	"./tarnax/tarnax_button_01": 3084,
	"./tarnax/tarnax_button_01.json": 3084,
	"./tarnax/tarnax_button_02": 7593,
	"./tarnax/tarnax_button_02.json": 7593,
	"./tarnax/tarnax_button_03": 3406,
	"./tarnax/tarnax_button_03.json": 3406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6532;